import requestAction from '../../utils/requestAction'

export const fetchProductSubgroups = (params: string = "") =>
  requestAction('PRODUCTSUBGROUP_LIST', params)(`productSubgroups`, 'GET')

export const fetchAllProductSubgroups = () =>
  fetchProductSubgroups('?all=true')